import { render, staticRenderFns } from "./CAirPreventive.vue?vue&type=template&id=d9b36012"
import script from "./CAirPreventive.vue?vue&type=script&lang=js"
export * from "./CAirPreventive.vue?vue&type=script&lang=js"
import style0 from "./CAirPreventive.vue?vue&type=style&index=0&id=d9b36012&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d9b36012')) {
      api.createRecord('d9b36012', component.options)
    } else {
      api.reload('d9b36012', component.options)
    }
    module.hot.accept("./CAirPreventive.vue?vue&type=template&id=d9b36012", function () {
      api.rerender('d9b36012', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CAirPreventive.vue"
export default component.exports